export enum ILiveCameraTab {
  LIVE_STREAM = 'LIVE_STREAM',
  RECORDINGS = 'RECORDINGS'
}
